import styled from "styled-components"

export const PromoBarContainer = styled.div`
  height: 40px;
  background-color: ${({ theme }) => theme.color.background};
  border-bottom: 1px solid ${({ theme }) => theme.color.commerceBorder};
  display: flex;
  justify-content: center;
  align-items: center;
  text-align: center;
  padding: 10px 0;

  p {
    font-size: ${12 / 16}rem;
    line-height: ${20 / 12}em;
  }
  a {
    font-weight: 500;
    color: ${({ theme }) => theme.color.promoBarlink};
    text-decoration: underline;
  }
  @media (min-width: ${({ theme }) => theme.breakpoint.mobileHorizontal}px) {
    p {
      font-size: ${14 / 16}rem;
      line-height: ${20 / 14}em;
    }
  }
  @media (min-width: ${({ theme }) => theme.breakpoint.mobileSmall}px) {
    height: 20px;
  }
`
